exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back[data-v-61a5d25d] {\n  cursor: pointer;\n}\n[data-v-61a5d25d] .slideXLeftIn {\n  pointer-events: none;\n}\n[data-v-61a5d25d] .slideXLeftIn.extra-menu {\n  -webkit-animation-name: slideXRightIn !important;\n          animation-name: slideXRightIn !important;\n}", ""]);

// exports
